<template>
  <div class="content">
    <el-card shadow="never">
      <!-- 查询 -->
      <el-row type="flex" justify="space-between">
        <el-form
          ref="searchForm"
          :model="searchForm"
          class="demo-form-inline"
          inline
        >
          <el-form-item label="订单编号:" prop="name">
            <el-input
              v-model.trim="searchForm.name"
              placeholder="请输入备注名称"
            />
          </el-form-item>

          <el-form-item label="url:" prop="url">
            <el-input
              v-model.trim="searchForm.url"
              type="textarea"
              :rows="4"
            placeholder="请输入url，多个值可用逗号分隔"
            resize="both"
            />
          </el-form-item>

          <div class="block">
            <span class="demonstration">开始时间:</span>
            <el-date-picker
              v-model="searchForm.dateUp"
              type="datetime"
              placeholder="选择日期和时间"
              :default-value="getDefaultStartTime()"
              @change="formatDate('dateUp',searchForm)"
            />
          </div>

          <div class="block">
            <span class="demonstration">结束时间:</span>
            <el-date-picker
              v-model="searchForm.dateEnd"
              type="datetime"
              placeholder="选择日期和时间"
              :default-value="getDefaultEndTime()"
              @change="formatDate('dateEnd',searchForm)"
            />
          </div>

          <div class="block">
            <span class="demonstration">添加时间:</span>
            <el-date-picker
              v-model="searchForm.datePut"
              type="datetime"
              placeholder="选择日期和时间"
              @change="formatDate('datePut',searchForm)"
            />
          </div>

          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch()"
            >查询
            </el-button>
<!--            <el-button icon="el-icon-refresh-right" @click="handleClear()"
            >重置</el-button
            >-->
          </el-form-item>
        </el-form>
      </el-row>
      <el-row class="rowSpace">

        <el-col :span="2">
          <el-button type="primary" @click="bulkEdit()"
            >批量修改</el-button
          ></el-col
        >
        <el-col :span="2">
          <el-button type="info" @click="dialogVisible = true"
            >导入订单</el-button
          ></el-col
        >
<!--        <el-col :span="3">
          <el-button type="info" @click="dialogVisibleProduct = true"
            >导入产品</el-button
          ></el-col
        >-->

        <el-dialog title="导入订单" :visible.sync="dialogVisible" width="30%">
          <el-upload
            ref="upload"
            :action="uploadOrderUrl"
            :on-success="handleSuccess"
            :on-error="handleError"
            :http-request="customRequest"
            :auto-upload="false"
            v-loading="isLoading"
          >
            <el-button slot="trigger" size="small" type="primary"
              >选择文件</el-button
            >
          </el-upload>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button
              style="margin-left: 10px"
              type="success"
              @click="submitOrderUpload"
              >开始导入</el-button
            >
          </span>
        </el-dialog>



        <el-dialog
          title="编辑订单"
          :visible.sync="dialogVisibleEditOrder"
          width="30%"
        >
          <el-form ref="form" :model="form" label-width="80px">
            <el-form-item label="订单状态">
              <el-select v-model="form.status" placeholder="选择状态">
                <el-option label="待处理" value="0"></el-option>
                <el-option label="已完成" value="1"></el-option>
                <el-option label="未完成" value="2"></el-option>
                <el-option label="已退款" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="备注">
              <el-input
                type="textarea"
                v-model="form.remark"
                placeholder="请输入内容"
                rows="10"
              ></el-input>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleEditOrder = false">取 消</el-button>
            <el-button
              style="margin-left: 10px"
              type="success"
              @click="submitEditOrder"
              >确认</el-button
            >
          </span>
        </el-dialog>

        <el-dialog
          title="批量编辑订单"
          :visible.sync="dialogVisibleBulkEdit"
          width="30%"
        >
          <el-form
            ref="BulkEditFormRef"
            :model="BulkEditForm"
            label-width="80px"
          >

            <div class="block">
              <span class="demonstration">执行时间:</span>
              <el-date-picker
                v-model="BulkEditForm.dateUp"
                type="datetime"
                placeholder="选择日期和时间"
                @change="formatDate('dateUp',BulkEditForm)"
              />
            </div>

            <div class="block">
              <span class="demonstration">结束时间:</span>
              <el-date-picker
                v-model="BulkEditForm.dateEnd"
                type="datetime"
                placeholder="选择日期和时间"
                @change="formatDate('dateEnd',BulkEditForm)"
              />
            </div>



          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisibleBulkEdit = false">取 消</el-button>
            <el-button
              style="margin-left: 10px"
              type="success"
              @click="submitBulkEdit"
              >确认</el-button
            >
          </span>
        </el-dialog>

        <!-- <el-col :span="8">
          <div>
            <el-radio-group
              size="small"
              @change="changeRadio($event)"
              v-model="searchForm.state"
            >
              <el-radio-button label="">全部</el-radio-button>
              <el-radio-button label="0">已上架</el-radio-button>
              <el-radio-button label="1">已下架</el-radio-button>
            </el-radio-group>
          </div>
        </el-col> -->
      </el-row>
      <!-- 表格 -->

      <el-table
        ref="table"
        :data="tableData"
        border
        style="width: 100%"
        height="540"
        :header-cell-style="tableHeaderColor"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column fixed prop="id" label="订单ID" width="100" />
        <el-table-column prop="name" label="备注名称" width="210" />
        <el-table-column prop="url" label="url" width="180" />
        <el-table-column prop="country" label="country" width="180" />

        <el-table-column prop="number" label="number" width="180" />

        <el-table-column prop="dateUp" label="执行时间" width="180" />
        <el-table-column prop="dateEnd" label="结束时间" width="180" />
        <el-table-column prop="datePut" label="上传时间" width="180" />
        <el-table-column
          prop="remark"
          label="备注"
          show-overflow-tooltip
          width="150"
        />

<!--        <el-table-column fixed="right" label="操作" width="220">
          &lt;!&ndash; <template v-if="isTrackListEmpty"><el-empty description="暂无数据"></el-empty></template> &ndash;&gt;
          <template slot-scope="scope">
            <el-button
              type="success"
              size="small"
              @click="
                editOrder(scope.row.orderId, scope.row.status, scope.row.remark)
              "
              >编辑</el-button
            >
            &lt;!&ndash;
            <el-button
              type="warning"
              size="small"
              @click="changeCourseStatus(scope.row.id, 0)"
              >下架</el-button
            >
            <el-button
              type="primary"
              size="small"
              @click="changeCourseStatus(scope.row.id, 1)"
              >上架</el-button
            > &ndash;&gt;
            &lt;!&ndash; <el-button size="small" @click="openDetail(scope.row.id)"
              >详情</el-button
            > &ndash;&gt;
            <el-button
              type="danger"
              size="small"
              @click="deletecourse(scope.row.orderId)"
              >删除</el-button
            >
            <el-button
              size="small"
              @click="
                changeView('/order/detail', { orderNo: scope.row.orderNo })
              "
              >详情</el-button
            >
          </template>
        </el-table-column>-->
      </el-table>
      <!-- 分页 -->
<!--      <el-pagination
        class="pagination"
        layout="->,total, prev, pager, next, jumper"
        :current-page="searchForm.page"
        :page-size="searchForm.limit"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />-->
      <!-- 详情--->
      <!-- <Detail ref="course_detail" /> -->
    </el-card>
  </div>
</template>

<script>
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
// 初始化插件
dayjs.extend(utc);
dayjs.extend(timezone);

import axios from "axios";
export default {
  name: "courseManage",
  // components: { Detail },
  data() {
    return {
      isLoading: false,
      dialogVisibleBulkEdit: false,
      dialogVisible: false,
      dialogVisibleProduct: false,
      dialogVisibleEditOrder: false,
      uploadOrderUrl: "/api/upload",
      uploadProductUrl: "/api/product/uploadExcelProduct",
      searchForm: {
        //current: 1,
       // limit: 30,
       // page: 1,
        url: "",
        // lecturer: "",
        name: "",
        datePut :null,
        dateUp :null,
        dateEnd :null

      },
      multipleSelection: [],
      total: 0, // 初始化应为 0，这里只做演示效果使用
      tableData: [],
      form: {},
      selectedIds: [], // 存储选中的 ID 集合
      BulkEditForm: {
        dateUp :null,
        dateEnd :null
      },
      lecturerList: [{ id: 123123, name: "知否君" }],
    };
  },
  created() {
    // 初始化表格数据
    this.getPageList();
  },
  // 钩子
  mounted() {
    // 初始化默认值
    this.searchForm.dateUp = dayjs()
      .tz("Asia/Shanghai")
      .startOf("month")
      .format("YYYY-MM-DD HH:mm:ss");
    this.searchForm.dateEnd = dayjs()
      .tz("Asia/Shanghai")
      .endOf("month")
      .format("YYYY-MM-DD HH:mm:ss");
  },
  methods: {
    async getPageList() {
      const result = await this.$axios.post("/api/quer", this.searchForm);
      if (result.data.code == 200) {
        // this.tableData = result.data.data.list.slice().reverse(); //当前数据倒序
        console.log(result.data.data)
        this.tableData = result.data.data;
        //this.total = result.data.data.total;
      } else {
        this.$message.error(result.data.message);
      }
    },
    // 获取时间
    // 获取当天的 00:00:00  （GMT+8）
    getDefaultStartTime() {
      const startOfMonth = dayjs().tz("Asia/Shanghai").startOf("month");
      return startOfMonth.toDate();
    },
    // 获取当天的 23:59:59
    getDefaultEndTime() {
      const endOfMonth = dayjs().tz("Asia/Shanghai").endOf("month");
      return endOfMonth.toDate();
    },
    // 格式化时间为 yyyy-MM-dd HH:mm:ss 并转换为 GMT+8
    formatDate(field, form) {
      // 检查字段值是否有效
      if (form[field]) {
        try {
          const formattedDate = dayjs(form[field])
            .tz("Asia/Shanghai")
            .format("YYYY-MM-DD HH:mm:ss");
          form[field] = formattedDate; // 更新为格式化后的时间
        } catch (error) {
          console.error(`格式化 ${field} 时间时出错:`, error);
        }
      }
    },

    // 点击上传按钮时触发
    submitOrderUpload() {
      this.isLoading = true;
      this.$refs.upload.submit();
    },
    customRequest(options) {
      const formData = new FormData();
      formData.append("file", options.file); //这里的 'file' 是后端接收文件的字段名

      axios
        .post(this.uploadOrderUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.code == "200") {
            options.onSuccess(response.data.message);
            this.dialogVisible = false;
            this.getPageList();
          } else {
            options.onError(response.data.message);
          }
        })
        .catch((error) => {
          options.onError(error);
        });
    },
    // 文件上传成功的回调
    handleSuccess(response, file, fileList) {
      this.isLoading = false;
      this.$message.success("上传成功");
      console.log("File uploaded successfully:", response);
      this.dialogVisible = false; // 上传成功后关闭弹窗
    },
    // 文件上传失败的回调
    handleError(err, file, fileList) {
      this.isLoading = false;
      console.error("Error uploading file:", err);
      this.$message.error("文件上传失败");
    },

    // 点击上传按钮时触发
    submitProductUpload() {
      this.isLoading = true;
      this.$refs.upload.submit();
    },
    customRequestProduct(options) {
      const formData = new FormData();
      formData.append("file", options.file); //这里的 'file' 是后端接收文件的字段名

      axios
        .post(this.uploadProductUrl, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((response) => {
          if (response.data.code == "200") {
            options.onSuccess(response.data.message);
            this.dialogVisibleProduct = false;
            this.getPageList();
          } else {
            options.onError(response.data.message);
          }
        })
        .catch((error) => {
          options.onError(error);
        });
    },
    // 文件上传成功的回调
    handleProductSuccess(response, file, fileList) {
      this.isLoading = false;
      this.$message.success("上传成功");
      console.log("File uploaded successfully:", response);
      this.dialogVisibleProduct = false; // 上传成功后关闭弹窗
    },
    // 文件上传失败的回调
    handleProductError(err, file, fileList) {
      this.isLoading = false;
      console.error("Error uploading file:", err);
      this.$message.error("文件上传失败");
    },
    bulkEdit() {
      if (this.multipleSelection.length === 0) {
        this.$message.warning("请先选择至少一个订单！");
        return;
      }
      this.dialogVisibleBulkEdit = true;
    },
    // 提交批量编辑
    async submitBulkEdit() {
      if (this.multipleSelection.length === 0) {
        this.$message.error("未选择任何订单！");
        return;
      }

      if (!this.BulkEditForm.dateUp || !this.BulkEditForm.dateEnd) {
        this.$message.error("请填写执行时间和结束时间！");
        return;
      }

      // 构造提交数据
      const payload = {
        ids: this.multipleSelection,
        dateUp: this.BulkEditForm.dateUp,
        dateEnd: this.BulkEditForm.dateEnd
      };

      try {
        // 发送 POST 请求到后端
        const response = await axios.post("/api/updateByDate", payload);
        // 检查响应状态
        if (response.data.code === 200) {
          this.$message.success("批量修改成功！");
          this.getPageList();
        } else {
          this.$message.error(`操作失败: ${response.data.message}`);
        }
      } catch (error) {
        console.error("提交批量修改时出错:", error);
        this.$message.error("提交失败，请稍后重试！");
      } finally {
        // 关闭对话框
        this.dialogVisibleBulkEdit = false;

        // 清空表单
        this.BulkEditForm.datePut = null;
        this.BulkEditForm.dateEnd = null;
        this.selectedIds = [];
      }
    },
    editOrder(orderId, status, remark) {
      this.form = {
        orderId: orderId,
        status: status,
        remark: remark,
      };
      this.dialogVisibleEditOrder = true;
    },
    async submitEditOrder() {
      try {
        const result = await this.$axios.post("/api/updateByRemaek", this.form);

        if (result.data.code === 200) {
          // 在成功后关闭对话框
          this.dialogVisibleEditOrder = false;
          this.$message.success(result.data.message);

          // 确保此方法存在并相应地更新 UI
          this.getPageList();
        } else {
          this.$message.error(result.data.message);
        }
      } catch (error) {
        console.error("发生错误：", error);
        this.$message.error("更新订单失败，请重试。");
      } finally {
        // 确保即使在出错的情况下也关闭对话框
        this.dialogVisibleEditOrder = false;
      }
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return "background-color:#dee1e9;color:#212121;font-weight: 500;";
    },
    // 切换tab
    changeRadio(value) {
      this.searchForm.state = value;
      this.getPageList();
    },
    //搜索
    handleSearch() {
      //this.searchForm.page = 1;
      this.getPageList();
    },
    //重置
    handleClear() {

      this.$refs["searchForm"].resetFields();
      // 重置与 el-select 绑定的数据属性
      this.searchForm.status = ""; // 或者设置为你希望的初始值
      this.getPageList();
    },
    // 切换每页显示条数
    handleSizeChange(val) {
      this.searchForm.size = val;
      this.searchForm.page = 1;
      this.getPageList();
    },
    // 点击某一页，跳转某一页
    handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getPageList();
    },
    changeCourseStatus(id, status) {
      let title = status == 0 ? "下架" : "上架";
      this.$confirm("确认要【" + title + "】该课程吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 业务操作
          this.$axios
            .post("/course/changeStatus", {
              id: id,
              status: status,
            })
            .then((res) => {
              if (res.data.success) {
                this.$message({ message: title + "成功！", type: "success" });
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },

    // 删除
    deletecourse(id) {
      this.$confirm("确认要删除该订单吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 删除逻辑
          this.$axios
            .get("/api/delete", {
              params: { id: id },
            })
            .then((res) => {
              if (res.data.code == 200) {
                this.$message({ message: "删除成功！", type: "success" });
                this.getPageList();
              } else {
                this.$message.error(res.data.message);
                this.getPageList();
              }
            })
            .catch((error) => {
              console.error("Delete operation failed:", error);
              this.$message.error("删除操作失败，请检查网络或联系管理员。");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    bulkDelete() {
      this.$confirm("确认要批量删除该订单吗, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.multipleSelection.forEach((row) => {
            this.$axios
              .get("/api/delete", {
                params: { id: row.orderId },
              })
              .then((res) => {
                if (res.data.code == 200) {
                  this.$message({
                    message: row.orderId + " 删除成功！",
                    type: "success",
                  });
                  this.getPageList();
                } else {
                  this.$message.error(res.data.message);
                  this.getPageList();
                }
              })
              .catch((error) => {
                console.error("Delete operation failed:", error);
                this.$message.error(
                  "批量删除操作失败，请检查网络或联系管理员。"
                );
              });

            // row.sum = row.sum ? row.sum : 1;
            // total += row.money * row.sum;
          });

          this.multipleSelection = [];
          this.getPageList();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    handleSelectionChange(val) {
      //this.multipleSelection = val;
      this.multipleSelection = val.map((item)=>item.id);
    },
    openDetail(id) {
      this.$refs.course_detail.drawer = true;
      this.$refs.course_detail.formData.id = id;
      this.$refs.course_detail.getCourseDetail();
    },
    // 路由跳转
    changeView(url, queryParams) {
      console.log(url);
      this.$router.push({
        path: url,
        query: queryParams,
      });
    },
    // 获取状态的类型，用于设置标签的样式
    getStateType(status) {
      switch (status) {
        case "0":
          return "primary"; // 待处理
        case "1":
          return "success"; // 完成
        case "2":
          return "warning"; // 未完成
        case "3":
          return "info"; // 未完成
        default:
          return "";
      }
    },
    // 获取状态的文本描述
    getStateText(status) {
      switch (status) {
        case "0":
          return "待处理";
        case "1":
          return "已完成";
        case "2":
          return "未完成";
        case "3":
          return "已退款";
        default:
          return "";
      }
    },
    // 过滤方法
    filterTag(value, filter) {
      if (Array.isArray(filter)) {
        return filter.some((item) => item.value === value);
      }
      return true;
    },
  },
  computed: {
    isTrackListEmpty() {
      return this.tableData.length === 0;
    },
  },
};
</script>

<style scoped>
.demo-form-inline {
  display: flex;
  align-items: center;
}
.el-form-item {
  margin-right: 10px; /* 控制每个表单项之间的间距 */
}
</style>



// WEBPACK FOOTER //
// src/view/order/List.vue